import { render, staticRenderFns } from "./NewPapasMergeQuestionsInsight.vue?vue&type=template&id=ca060fc4&scoped=true"
import script from "./NewPapasMergeQuestionsInsight.vue?vue&type=script&lang=js"
export * from "./NewPapasMergeQuestionsInsight.vue?vue&type=script&lang=js"
import style0 from "./NewPapasMergeQuestionsInsight.vue?vue&type=style&index=0&id=ca060fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca060fc4",
  null
  
)

export default component.exports